<template>
  <div class="upload-area" :style="{height: height + 'px'}">
    <el-upload class="myCommenUpload" accept="image/jpeg, image/jpg, image/png" :multiple="false" drag action="null" :http-request="httpUpload" :show-file-list="false">
      <div v-loading="loading" class="uploadBox" :style="{backgroundImage: url ? 'url(' + $baseURL + '/common/service/getFile/' + url + ')' : 'none'}">
        <div :style="{lineHeight: height/2 + 'px'}">拖拽文件到此处 或 点击上传</div>
        <div :style="{lineHeight: height/2 + 'px'}">{{text}}</div>
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: ['height', 'text', 'img'],
  data () {
    return {
      url: '',
      loading: false
    }
  },
  created () {
    this.url = this.img
  },
  methods: {
    httpUpload (item) {
      this.loading = true

      // 校验文件格式
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
      if (!allowedTypes.includes(item.file.type)) {
        this.$message.error('仅支持jpg、jpeg、png格式的图片')
        this.loading = false
        return false
      }

      const formData = new FormData()
      formData.append('file', item.file)
      this.$http.post('/common/service/uploadFile', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((res) => {
        this.url = res.data.url
        this.$emit('success', res.data.url, item.file.name)
        this.$message.success('上传成功')
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less">
.upload-area {
  height: 100%;
  .myCommenUpload {
    height: 100%;
    width: 100%;
    .el-upload {
      display: block;
    }
    .uploadBox {
      background-position: center right;
      background-size: contain;
      background-repeat: no-repeat;
      text-align: left;
      padding: 0 5px;
    }
    .el-upload-dragger {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
